import { IErrorContent, IProps } from '../types.ts';

export const getErrorContent = (errorCode: IProps['errorCode']): IErrorContent => {
    switch (errorCode) {
        case 404:
            return {
                title: '404',
                message: 'Page not found',
                actionTitle: 'Back to Dashboard',
            };
        case 500:
            return {
                title: '500',
                message: 'Internal server error',
                actionTitle: 'Retry',
            };
    }
};
